exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".compositExpression .cm-s-base16-light.CodeMirror{height:240px!important}.sqlexpression .cm-s-base16-light.CodeMirror{height:50px!important}", ""]);

// exports
